<template>
	<div class="Tickets">
		<div class="buttons">
			<vs-button
				v-if="$store.state.auth.role === 'manager'"
				@click="$router.push('/ticket/create')"
			>{{ $t('addTicket') }}</vs-button>
		</div>
		<div class="admin-ticket-filters">
			<div class="vx-row">
				<div
					class="admin-ticket-filters__item vx-col mt-3"
				>
					<v-select
						v-model="managerFilter"
						:reduce="item => item.id"
						:options="managers"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						:placeholder="$t('manager')"
						@input="filter"
						label="full_name"
						class="single-row-select w-full"
						multiple
					>
						<template slot="selected-option" slot-scope="option">
							{{ option.last_name }}
						</template>
					</v-select>
				</div>
				<div
					class="admin-ticket-filters__item vx-col mt-3"
				>
					<v-select
						v-model="authorFilter"
						:reduce="item => item.id"
						:options="authors"
						:dir="$vs.rtl ? 'rtl' : 'ltr'"
						:placeholder="$t('author')"
						@input="filter"
						label="full_name"
						class="single-row-select w-full"
					/>
				</div>
				<div class="admin-ticket-filters__item search vx-col flex items-center mt-3">
					<vs-input
						v-model="searchLike"
						@input="filter"
						icon="search"
						icon-after
						:placeholder="$t('searchByNameAndClient')"
						class="w-full"
					/>
				</div>
				<div class="admin-ticket-filters__item search vx-col flex items-center mt-3">
					<vs-checkbox
						@input="filter"
						v-model="searchPremium"
						class="w-full"
					>
						{{ $t('orderOnlyPremium')  }}
					</vs-checkbox>
				</div>
				<div class="admin-ticket-filters__item vx-col mt-3">
					<vs-custom-button
						color="dark"
						type="border"
						@click="reset"
						class="vs-custom-button w-full pl-1 pr-1 w-full pt-1 pb-1"
					>{{ $t('reset') }}</vs-custom-button>
				</div>
			</div>
		</div>
		<vx-card class="my-8">
			<vs-tabs v-if="tabs.length > 0">
				<vs-tab
					v-for="tab in tabs"
					:key="tab.title"
					:value="indexTab"
					:counter="getTabCounter(orders[tab.key])"
					:label="$t(tab.title)"
				>
					<div class="tab-text">
						<OrderTable
							:tab="tab"
							:options ="options"
							:managerFilter = "managerFilter"
							:authorFilter = "authorFilter"
							:searchLike = "searchLike"
							:searchPremium = "searchPremium"
							:key="componentKey"
						/>
					</div>
				</vs-tab>
			</vs-tabs>
		</vx-card>
	</div>
</template>

<script>
import vSelect from "vue-select";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import orderHeadersList from "@/assets/configs/orderHeadersList";
import OrderTable from "@/views/Tickets/OrderTable.vue";
import { $t } from "@primevue/themes";

export default {
	name: "Tickets",
	components: {
		OrderTable,
		vSelect,
	},
	mixins: [databaseManager, notifier],
	data() {
		return {
			componentKey: 0,
			managers: [],
			authors: [],
			managerFilter: null,
			authorFilter: null,
			searchLike: null,
			searchPremium: null,

			idOrder: 0,
			date: new Date(),
			indexTab: 0,
			tabs: [],
			orders: {
				new: '',
				in_progress: '',
				patch_mode: '',
				waiting_approve: '',
				completed: '',
				client_not_answer: '',
				processing: '',
				waiting_payment: '',
				waiting_author: '',
				failed: '',
				failed_with_payout: '',
				all: '',
				trash : '',
			},
			tabsHasMessageSet: new WeakSet(),
			subjects: [],
			works: [],
			levels: [],
			field: [],

			options: [],

		};
	},
	watch: {
		// off() {
		// 	this.filter();
		// },
		// to() {
		// 	this.filter();
		// },
	},
	methods: {
		forceRerender() {
			this.componentKey += 1;  
		},
		getTabCounter(orders) {
			// let newTabCounter = {
			// 	value: orders,
			// 	color: this.tabsHasMessageSet.has(orders) ? "orange" : undefined
			// };
			let newTabCounter = {
				value: 0,
				color: undefined,
			};

			if(orders > 0) {
				newTabCounter = {
					value: orders,
					color: "orange",
				};
			}

			return newTabCounter;
		},


		findTicket(tab, id) {
			const res = this.orders[tab].filter(
				(order) => order.id === id
			)[0];
			return res;
		},
		findTicketAnywhere(id) {
			let ticket;
			for(let tab of this.tabs) {
				ticket = this.findTicket(tab.key, id);

				if(ticket !== undefined) break;
			}

			return ticket;
		},
		// sortTab(tab) {
		// 	this.orders[tab].sort((a, b) => {
		// 		if(!b.task && a.task) return -1;
		// 		if(!a.task && b.task) return 1;
		// 		if(!a.task && !b.task) return 0;

		// 		if(a.task.date_time > b.task.date_time) return 1;
		// 		if(a.task.date_time < b.task.date_time) return -1;
		// 		return 0;
		// 	});
		// },
		// sortTickets() {
		// 	for(let tab in this.orders) {
		// 		this.sortTab(tab);
		// 	}
		// },

		// deepFind(obj, path) {
		// 	if (!path) return "";
		// 	let paths = path.split("."),
		// 		current = obj,
		// 		i;

		// 	for (i = 0; i < paths.length; ++i) {
		// 		if (current[paths[i]] === undefined) {
		// 			return undefined;
		// 		} else {
		// 			current = current[paths[i]];
		// 		}
		// 	}
		// 	return current;
		// },
		addSortWrappers(tab) {
			for(let item of this.orders[tab.key]) {
				if(item.client) {
					item.client.toString = function() { return this.full_name; }
				} else {
					item.client = "";
				}

				if(item.author) {
					item.author.toString = function() { return this.username; }
				} else {
					item.author = "";
				}

				if(item.task) {
					item.task.toString = function() { return this.date_time; }
				} else {
					item.task = "";
				}
			}
		},
		async filter(options = null) {
			this.forceRerender();
			this.options = options;
			for(let item of this.tabs) {
				try {
					let requestOptions = {
						limit: 0,
						offset: 0,
					};

					requestOptions.type = item.key;

					if(this.managerFilter != null) {
						requestOptions.manager = this.managerFilter;
					}
					if(this.authorFilter != null) {
						requestOptions.author = this.authorFilter;
					}
					if(this.searchLike != null) {
						requestOptions.name = this.searchLike;
					}
					if(this.searchPremium != null && this.searchPremium == true) {
						requestOptions.premium = '1';
					}


					let bigData = await this.dbGetFilteredTickets(requestOptions);
					this.orders[item.key]  = bigData.countAllUnreadChat;

				} catch (e) {
					this.notifyError(e.message);
				}
			}
		},
		addFullName(item) {
			let output = [];
			const firstName = item.first_name;
			const lastName = item.last_name;

			if(firstName) output.push(firstName);
			if(lastName) output.push(lastName);

			item.full_name = output.join(" ") || `#${item.id}`;

			return item;
		},
		async reset() {
			this.managerFilter = null;
			this.authorFilter = null;
			this.searchLike = null;
			this.searchPremium = null;
			// this.selectedClient = null;
			// this.selectedWork = null;
			// this.selectedLevel = null;
			// this.off = "";
			// this.to = "";
			// this.search = "";
			// this.selectedName = "";

			await this.filter();
		},
	},
	computed: {
		minDate() {
			return new Date();
		},
		pathToAuthor() {
			if(this.$store.state.auth.role === "admin") {
				return 'author';
			} else if(this.$store.state.auth.role === "manager") {
				return 'authorM';
			}
		},
		pathToClient() {
			if(this.$store.state.auth.role === "admin") {
				return 'client';
			} else if(this.$store.state.auth.role === "manager") {
				return 'clientM';
			}
		},
	},
	async created() {
		let headers;
		const role = this.$store.state.auth.role;

		let res = await this.$http.get('/'+this.$store.state.auth.role+'/profile');
		await this.$store.dispatch('updateUserInfo', res.data.data)

		const user = this.$store.state.auth.user;

		if(role == 'manager') {
			if(user.type == '1') {
				headers = orderHeadersList.getHeaders(role);
			}
			if(user.type == '2') {
				headers = orderHeadersList.getHeaders('manager2');
			}
		} else {
			headers = orderHeadersList.getHeaders(role);
		}
		this.field = headers.field;
		this.tabs = headers.tabs;
		// if(this.$store.state.auth.user.type && this.$store.state.auth.user.type == 2) {
		// 	return this.tabs.filter(r => r.key !== "processing");
		// }

		// console.log(this.$store.state);
	},
	async mounted() {
		this.managers = (await this.dbGetMangers()).map(this.addFullName);
		this.authors = (await this.dbGetAuthors()).map(this.addFullName);

		// console.log(this.managers);

		this.levels = (
			await this.$http.get("/settings/get-quality-levels")
		).data.data;

		this.works = (await this.$http.get("/settings/get-work-types")).data.data;
		this.subjects = (await this.$http.get("/settings/get-subjects")).data.data;

		await this.filter();

		// this.authors = (await this.dbGetAuthors()).map(this.addFullName);
	},
};
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables.scss";
@import "../../assets/scss/vuexy/functions.scss";

	// span.vs__selected {
	// 	margin-right: 10px;;
	// }

	.vs__deselect {
		float: left;
	}

	.slcColorSelect {
		background-color: red;
	}

.admin-ticket-filters {
	&__item {
		width: 11.111%;

		@media screen and (max-width: 1920px) {
			// width: 33.333%;
			width: 25%;
		}

		@media screen and (max-width: 578px) {
			width: 50%;
		}
	}

	&__date {
		@media screen and (max-width: 578px) {
			width: 100%;
		}
	}

	.search {
		.vs-input {
			overflow: hidden;
		}

		.vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		@media screen and (max-width: 578px) {
			width: 100%;
			order: -1;
		}
	}

	.vs__dropdown {
		&-menu {
			position: absolute !important;
			max-height: 160px !important;
			min-width: 230px !important;
			z-index: 100000;

			@media screen and (max-width: 1600px) {
				min-width: 100% !important;
			}
		}

		&-option {
			position: relative !important;
			width: 100%;
			text-overflow: ellipsis;
			overflow-x: hidden;
		}
	}
}

.con-exemple-prompt {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}

.viewTask {
	.vs-popup--title h3 {
		color: $primary;
	}

	.vs-popup--content {
		padding: 0;
	}

	.vs-popup--close {
		color: $primary;
	}

	table {
		width: 100%;

		td {
			padding-bottom: 4px;
		}
	}

	.body {
		padding: 1rem;

		table {
			margin-left: -2px;
		}

		p {
			padding-top: 10px;
			font-size: rem(14px);
		}
	}

	.footer {
		border-top: 1px solid rgba(0, 0, 0, 0.05);
		padding: 0.5rem 1rem;
		display: flex;
		justify-content: flex-end;

		button {
			margin-left: 10px;
		}
	}
}

.Tickets {
	.buttons {
		justify-content: flex-end;
	}

	.button-task {
		border-radius: 22px;
		padding: 0.25rem 0.7rem !important;
	}

	.add-affair_admin {
		margin-right: 25px;
	}

	.author-header {
		display: flex;
		justify-content: center;
	}

	.tickets__datepicker {
		@media screen and (max-width: 1400px) and (min-width: 1301px) {
			width: 160px !important;
		}

		@media screen and (max-width: 1300px) and (min-width: 1201px) {
			width: 130px !important;
		}
	}


	.filter {
		border-bottom: 1px solid #e5e5e5;
		padding-bottom: 1rem;
		padding-top: 0.5rem;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

		.date {
			display: flex;
			align-items: center;
		}

		.vx-input-group .vx-input-group-default .vs-input {
			width: 150px;
		}

		.search .vs-icon {
			height: 100%;
			width: 35px;
			background: $primary;
			position: absolute;
			top: 0;
			right: 0;
			color: white !important;
			display: flex;
			align-items: center;
			justify-content: center;
			border-top-right-radius: 4px;
			border-bottom-right-radius: 4px;
			font-size: 22px;
		}

		.search .vs-con-input-label {
			width: 260px;

			@media screen and (max-width: 1200px) {
				width: 100%;
			}
		}
	}

	.vs-table {
		margin-top: 10px;

		tr {
			border-top: 1px solid #cfcfcf;

			&:last-child {
				border-bottom: 1px solid #cfcfcf;
			}
		}
	}

	.con-vs-tabs .con-slot-tabs {
		overflow: visible;
	}

	.task {
		background-color: #3ac47d;
		border-radius: 10px;
		padding: 4px 10px;
		color: white;
	}

	.counter {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #f0ad4e;
			color: white;
			border-color: #f0ad4e;
		}
	}

	.counterAuthor {
		display: inline-block;
		padding: 5px;
		border-radius: 100%;
		font-weight: 600;
		width: 20px;
		height: 20px;
		font-size: 0.7rem;
		border: 1px solid #cfcfcf;
		display: flex;
		align-items: center;
		justify-content: center;
		line-height: 1;

		&.warn {
			background-color: #756add;
			color: white;
			border-color: #756add;
		}
	}

	.fade-enter-active,
	.fade-leave-active {
		transition: opacity 0.5s;
	}

	.inputInTable {
		border: 0;
		resize: none;
	}

	.fade-enter, .fade-leave-to
	{
		opacity: 0;
	}

	.buttons {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		@media screen and (max-width: 375px) {
			button {
				margin: 5px 0;
			}
		}
	}

	.vs-tabs--content {
		padding: 0;
		margin-top: 10px;
	}

	.vs-con-table .vs-con-tbody {
		border: 0;
		background-color: transparent;
	}

	.vs-table-text{
		cursor: pointer;
		user-select: none;
	}
}
</style>
